/* AVXT buy path, final 2026-09-07. Two jobs, nothing else:
   1. the sticky buy bar hides only while the in-column Add to cart is fully visible above it;
   2. cart quantity changes post on change; the Update button hides once bound and the
      sentence "Quantity changes save on their own." prints.
   No arithmetic on prices anywhere. Load with defer before </body>. */
(function () {
  'use strict';

  /* 1. Sticky buy bar (PDP). Default visible; no observer = always visible. */
  var bar = document.querySelector('[data-avxt-sticky]');
  var form = document.getElementById('avxt-product-form');
  var addBtn = form && form.querySelector('button[name="add"]');
  if (bar && addBtn && 'IntersectionObserver' in window) {
    var barHeight = bar.offsetHeight || 96;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        bar.classList.toggle('is-hidden', e.isIntersecting && e.intersectionRatio >= 1);
      });
    }, { threshold: [1], rootMargin: '0px 0px -' + barHeight + 'px 0px' });
    io.observe(addBtn);
  }

  /* 2. Cart quantities. */
  var cartForm = document.getElementById('avxt-cart-form');
  if (!cartForm) return;
  var inputs = cartForm.querySelectorAll('input[name="updates[]"]');
  if (!inputs.length) return;
  var updateBtn = cartForm.querySelector('[data-avxt-update]');
  var note = cartForm.querySelector('[data-avxt-qnote]');
  if (updateBtn) updateBtn.hidden = true;
  if (note) note.textContent = 'Quantity changes save on their own.';

  var timer = null;
  function fail() {
    if (updateBtn) updateBtn.hidden = false;
    if (note) note.textContent = '';
  }
  function post(input) {
    var line = parseInt(input.getAttribute('data-line'), 10);
    var qty = parseInt(input.value, 10);
    if (isNaN(line) || isNaN(qty) || qty < 0) return;
    input.disabled = true;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function (r) {
      if (!r.ok) throw new Error(String(r.status));
      return r.json();
    }).then(function () {
      window.location.reload();
    }).catch(function () {
      input.disabled = false;
      fail();
    });
  }
  inputs.forEach(function (input) {
    input.addEventListener('change', function () {
      clearTimeout(timer);
      timer = setTimeout(function () { post(input); }, 350);
    });
  });
  cartForm.querySelectorAll('[data-avxt-qty]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = btn.parentNode.querySelector('input[name="updates[]"]');
      if (!input) return;
      var v = parseInt(input.value, 10) || 0;
      v = Math.max(0, v + (btn.getAttribute('data-avxt-qty') === '+' ? 1 : -1));
      input.value = v;
      input.dispatchEvent(new Event('change'));
    });
  });
})();

/* 3. Colour variants (added 2026-09-08).
   Signature is one product with White and Black as variants. The radio group inside the
   product form is the source of truth: picking one rewrites the hidden variant id, the
   price, the availability of both Add to cart buttons, the colour label, and the URL, and
   asks the product section to bring that colour's photo forward. With JavaScript off the
   <noscript> ?variant= links still reach every colour, so nothing here is load-bearing. */
(function () {
  'use strict';
  var buy = document.querySelector('[data-avxt-buy]');
  if (!buy) return;
  var radios = buy.querySelectorAll('[data-avxt-option]');
  if (!radios.length) return;

  var hidden = buy.querySelector('[data-avxt-variant-id]');
  var priceEl = buy.querySelector('[data-avxt-price]');
  var labelEl = buy.querySelector('[data-avxt-colour-label]');
  var addBtn = buy.querySelector('[data-avxt-add]');
  var stickyPrice = document.querySelector('[data-avxt-sticky-price]');
  var stickyAdd = document.querySelector('[data-avxt-sticky-add]');
  var section = document.querySelector('[data-avxt-product]');

  function apply(radio) {
    var d = radio.dataset;
    var available = d.variantAvailable === 'true';

    if (hidden) hidden.value = d.variantId;
    if (priceEl) priceEl.textContent = d.variantPrice;
    if (labelEl) labelEl.textContent = radio.value;
    if (stickyPrice) stickyPrice.textContent = d.variantPrice;

    [addBtn, stickyAdd].forEach(function (b) {
      if (!b) return;
      b.disabled = !available;
      b.textContent = available ? 'Add to cart' : 'Sold out';
    });

    if (d.variantUrl && window.history && window.history.replaceState) {
      try { window.history.replaceState({}, '', d.variantUrl); } catch (e) {}
    }
    if (section) {
      section.dispatchEvent(new CustomEvent('avxt:variant', {
        detail: { mediaId: d.variantMedia || '', colour: radio.value }
      }));
    }
  }

  Array.prototype.forEach.call(radios, function (r) {
    r.addEventListener('change', function () { if (r.checked) apply(r); });
  });

  var checked = buy.querySelector('[data-avxt-option]:checked');
  if (checked) apply(checked);
})();

/* 4. Country and currency picker (2026-09-08). Submit on change; without JavaScript the
   form keeps its own submit button, so every market stays reachable either way. */
(function () {
  'use strict';
  Array.prototype.forEach.call(document.querySelectorAll('[data-avxt-loc]'), function (sel) {
    sel.addEventListener('change', function () { sel.form && sel.form.submit(); });
  });
})();
